import React, { useEffect, useState } from "react";
import styles from "../Header.module.scss";

import { GRADES } from "util/config";
import { Dropdown, Avatar, Tag, Badge } from "antd";
import IconProfile from "assets/icons/icon-profile-cu.png";
import iconLogOut from "assets/icons/icon-logout-cu.png";
import IconDropdownBlack from "assets/icons/icon-dropdown-black.svg";
import MenuDropdown from "components/Menu/MenuDropdown";
import KidProfile from "assets/icons/profile/Default.svg";
import ListDropdown from "components/List/ListDropdown";
import { TranslateLanguage } from "util/Translate";
import { vocabUserRightNav } from "util/Translate.variable";
import useWindowSize from "hook/useWindowSize";
import { Modal, Button } from "antd";
import iconLogoout from "assets/icons/profile/icon-log-out-cu.svg";
import { ExclamationOutlined } from "@ant-design/icons";
import { getLocalStorage } from "util/localstorage";
import { CorrectTimeZoneManager } from "util/helper";

const translate = new TranslateLanguage();
translate.addMaping(vocabUserRightNav);

export default function UserRightNav(props) {
  const { user } = props;
  const { width } = useWindowSize();

  const [visibleLogout, setVisibleLogout] = useState(false);
  const [isTimeCorrect, setIsTimeCorrect] = useState(false);

  useEffect(() => {
    TimeFunction();
  }, [getLocalStorage("time-incorrect")]);

  const TimeFunction = () => {
    const timeData = getLocalStorage("time-incorrect");
    setIsTimeCorrect(timeData);
  };

  const handleClickSignout = () => {
    setVisibleLogout(true);
  };

  const handleCancelSignout = () => {
    setVisibleLogout(false);
  };

  const handleSignOut = () => {
    props.onSignOut();
  };

  return (
    <div className={styles.headerProfile}>
      <div className={styles.subProfile}>
        <span
          style={{ display: "flex", cursor: "pointer" }}
          onClick={() => {
            props.props.history.push("/profile");
          }}
        >
          {width <= 500 ? (
            <></>
          ) : (
            <Badge
              className={styles.display}
              count={
                isTimeCorrect ? (
                  <div
                    style={{
                      backgroundColor: "red",
                      padding: ".1rem",
                      borderRadius: "100%",
                    }}
                  >
                    <ExclamationOutlined style={{ color: "white" }} />
                  </div>
                ) : (
                  <></>
                )
              }
              size="small"
              offset={[-5, 10]}
            >
              <Avatar
                className={styles.avatar}
                src={user?.imageProfile || KidProfile}
              />
            </Badge>
          )}
          <div className={styles.nameAndSchool}>
            <div className={styles.divDisplayName}>
              <span className={styles.displayName}>
                {user?.displayName || "Guest"}
              </span>
            </div>
          </div>
        </span>
        <Dropdown
          overlay={MenuDropdown([
            {
              label: (
                <ListDropdown
                  text={translate.convert("ข้อมูลผู้ใช้งาน")}
                  icon={IconProfile}
                  action={props.onProfile}
                />
              ),
            },
            {
              label: (
                <ListDropdown
                  text={translate.convert("ออกจากระบบ")}
                  icon={iconLogOut}
                  action={handleClickSignout}
                />
              ),
            },
          ])}
          trigger={["click"]}
          placement="bottomRight"
          arrow
        >
          <div style={{ cursor: "pointer" }}>
            <Avatar alt="dropdownprofile" src={IconDropdownBlack} />
          </div>
        </Dropdown>
      </div>
      <Modal
        open={visibleLogout}
        onCancel={handleCancelSignout}
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "4rem",
            }}
          >
            <Button
              type="primary"
              onClick={handleSignOut}
              style={{ width: "35%" }}
            >
              ยืนยัน
            </Button>
            <Button onClick={handleCancelSignout} style={{ width: "35%" }}>
              ยกเลิก
            </Button>
          </div>
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fde8f1",
              width: "100px",
              height: "100px",
              borderRadius: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={iconLogoout}
              alt="iconLogoout"
              style={{ width: "50px" }}
            />
          </div>
          <div
            style={{
              marginTop: "2rem",
              fontSize: "1.5rem",
              fontWeight: "bold",
            }}
          >
            ออกจากระบบ
          </div>
          <div style={{ marginBottom: ".75rem" }}>
            คุณต้องการออกจะระบบหรือไม่?
          </div>
        </div>
      </Modal>
    </div>
  );
}
